// extracted by mini-css-extract-plugin
export default {"cart-items-holder":"Cart_cart-items-holder__kbo-1","total":"Cart_total__JkkUJ","actions":"Cart_actions__2-Iva"};